module.exports = __webpack_public_path__ + "static/CrearContenido-f70bc4fe7a977a5aa94c12f2189068ec.webp";